<router-outlet></router-outlet>
<p-toast 
  position="bottom-right"
  showTransitionOptions="200ms"
  showTransformOptions="translateY(100%)"
  hideTransitionOptions="200ms"
  hideTransformOptions="translateY(-100%)"
/>
<p-confirmDialog />